import { render, staticRenderFns } from "./ImageTab.vue?vue&type=template&id=d37dbd26&"
import script from "./ImageTab.vue?vue&type=script&lang=js&"
export * from "./ImageTab.vue?vue&type=script&lang=js&"
import style0 from "./ImageTab.vue?vue&type=style&index=0&id=d37dbd26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports